export { default } from './SliderWrapper';
